//App's urls
export const HOME_ROUTE = "/";
export const CCGT_ROUTE = "/ccgt";
export const WIND_ROUTE = "/wind";
export const BIO_ROUTE = "/bioenergy";
export const CCGT_ROUTE_MODE_SINGLE = "/ccgt/:plantName";
export const WIND_ROUTE_MODE_SINGLE = "/wind/:plantName";
export const BIO_ROUTE_MODE_SINGLE = "/bioenergy/:plantName";

const AppRoutes = {
    HOME_ROUTE,
    CCGT_ROUTE,
    CCGT_ROUTE_MODE_SINGLE,
    WIND_ROUTE,
    WIND_ROUTE_MODE_SINGLE,
    BIO_ROUTE,
    BIO_ROUTE_MODE_SINGLE
}

export default AppRoutes;